<template>
  <div>
    <v-container fluid>
      <!-- TOP PART -->
      <v-row>
        <v-col cols="4">
          <h4>{{ $t("ration.prepareRelation") }}</h4>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="4" class="text-center">
          <p v-if="rationType == 'system'">
            Step 2 of 2 | {{ $t("ration.animalSelection") }}
          </p>
          <p v-else>Step 3 of 3 | {{ $t("ration.animalSelection") }}</p>
        </v-col>
        <v-spacer></v-spacer>

        <v-col cols="4" class="text-right"> </v-col>
      </v-row>
      <v-divider class="my-4"></v-divider>

      <!-- INGREDIENTS SELECTIONS HERE -->

      <v-row class="pb-3">
        <v-col cols="8">
          <h3>
            Rations Suggestions
            <span class="green--text" style="font-size: 14px"
              >{{ allAnimalsData.individualAnimals.length }} Animal
              Selected</span
            >
          </h3>
        </v-col>
        <v-col cols="4" class="text-right">
          <v-btn outlined color="primary" class="mr-2" @click="back">
            Back
          </v-btn>
          <v-btn
            color="primary"
            @click="openCreateRationDialog"
            :disabled="enableSaveRationBtn()"
          >
            Save Ration(s)
          </v-btn>
        </v-col>
      </v-row>
      <v-card
        elevation="0"
        class="my-2"
        v-for="item in suggestions"
        :key="item.id"
      >
        <v-card-text>
          <div class="gray2 my-2 px-4" style="border-radius: 2px">
            <v-row>
              <v-col cols="4" class="d-flex justify-start align-center">
                <!-- <p class="mb-0"> -->
                <v-icon @click="expandToggle(item.animalId)"
                  >{{
                    isExpanded[item.animalId]
                      ? "mdi-chevron-up"
                      : "mdi-chevron-down"
                  }}
                </v-icon>
                {{ item.animalId }}
              </v-col>
              <v-col cols="8" class="d-flex align-center justify-end">
                <v-alert
                  class="mx-4"
                  dense
                  color="#FAF5DA"
                  style="
                    border: 1px solid #ffb443;
                    align-items: center !important;
                    margin-bottom: 0px !important;
                    font-size: 14px;
                    max-width: 547px;
                  "
                  v-if="item.ration.status_type == 'active'"
                >
                  Ration Name:
                  <b>{{ item.ration.name || "_______" }}</b
                  >&nbsp;&nbsp;&nbsp;

                  <span v-if="item.ration.status_type == 'active'"
                    >Duration:
                  </span>
                  <b v-if="item.ration.status_type == 'active'"
                    >{{ item.ration.duration || 0 }}
                  </b>
                  &nbsp;&nbsp;<v-icon
                    color="blue"
                    class="pl-1"
                    @click="openRationCreateModal(item)"
                    >mdi-pencil</v-icon
                  >
                </v-alert>

                <p class="mb-0">
                  <v-btn
                    color="green white--text"
                    height="40px"
                    @click="openRationCreateModal(item)"
                    >Generate</v-btn
                  >

                  <v-icon color="error" class="pl-2">mdi-trash-can</v-icon>
                </p>
              </v-col>
            </v-row>
          </div>
          <span
            :style="
              isExpanded[item.animalId] ? 'display:block' : 'display:none'
            "
          >
            <ration-summary-component
              :rationPriority="rationPriority"
              :suggestedRations="item"
              @generateAllData="generateAllData"
              @rationData="generateRations"
            ></ration-summary-component>
          </span>
          <!-- <v-expansion-panels focusable flat class="mt-5" v-model="panel">
            <v-expansion-panel
              class="general-information mb-4"
              v-for="(item, index) in suggestions"
              :key="index"
            >
              <v-expansion-panel-header
                class="subtitle-1"
                append-icon="mdi-heart"
              >
                {{ item.animalId }}
                <span style="order: 2; display: flex; justify-content: end"
                  ><v-icon
                    color="error"
                    class="pl-2"
                    @click.stop.prevent="
                      destroyIngredientSuggestionDialog(item)
                    "
                    >mdi-trash-can</v-icon
                  ></span
                >
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <ration-summary-component
                  :rationPriority="rationPriority"
                  :suggestedRations="item"
                  @generateAllData="generateAllData"
                  @rationData="generateRations"
                ></ration-summary-component>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels> -->
        </v-card-text>
      </v-card>
    </v-container>
    <sub-group-animal-details
      v-if="showSubGroupAnimalDetails"
      :dialogI="showSubGroupAnimalDetails"
      @closeDialog="showSubGroupAnimalDetails = false"
    >
    </sub-group-animal-details>

    <save-ration-dialog
      v-if="saveRation"
      :dialogI="saveRation"
      :rationLists="currentAnimalRation"
      @closeDialog="saveRation = false"
      @rationCreated="rationCreated"
      :suggestionType="rationPriority"
    >
    </save-ration-dialog>
    <create-ration-dialog
      v-if="createRation"
      :dialogU="createRation"
      @closeDialog="createRation = false"
      :noOfSavedRations="suggestions?.length"
    >
    </create-ration-dialog>
    <confirm-box
      v-if="deleteSuggestion"
      :dialog="deleteSuggestion"
      title="Warning"
      message="Are you sure you want to delete this record?"
      confirmBtnText="Delete"
      :confirmData="itemToDelete"
      @confirm:action="deleteIngredientSuggestionConfirmed"
    />
  </div>
</template>
<script>
import loadingMixin from "@/mixins/LoadingMixin";
import SubGroupAnimalDetails from "@/views/feed_management/ration_library/DialogBox/SubGroupAnimalDetails";
import SaveIndividualRationDialog from "@/views/feed_management/ration_library/DialogBox/SaveIndividualRationDialog";
import CreateRation from "@/views/feed_management/ration_library/DialogBox/CreateRation";
import RationSummaryComponent from "@/views/feed_management/ration_library/components/_IndividualRationSummary";
import {
  getSuggestionsForIndividualRation,
  deleteGeneratedRationIngredient,
} from "@/graphql/Feed.gql";
import { generateRationIndividualAnimal } from "@/graphql/FeedMgmt.gql";
import gql from "graphql-tag";
import FeedService from "@/_services/FeedService";
import ConfirmBox from "@/components/ConfirmBox.vue";

export default {
  apollo: {
    getSuggestionsForIndividualRation: {
      query: getSuggestionsForIndividualRation,
      update: (data) => console.log(data),
      fetchPolicy: "no-cache",
      variables() {
        return {
          rationIds: this.rationIds,
        };
      },
      skip: true,
      result({ data }) {
        if (
          data.getSuggestionsForIndividualRation &&
          data.getSuggestionsForIndividualRation.length === 0
        ) {
          this.generateSuggestions();
        } else {
          this.suggestions = data.getSuggestionsForIndividualRation;
        }
      },
    },
  },
  mixins: [loadingMixin],
  components: {
    "sub-group-animal-details": SubGroupAnimalDetails,
    "save-ration-dialog": SaveIndividualRationDialog,
    "create-ration-dialog": CreateRation,
    "ration-summary-component": RationSummaryComponent,
    "confirm-box": ConfirmBox,
  },
  data() {
    return {
      isExpanded: {},
      deleteSuggestion: false,
      itemToDelete: null,
      rationType: "",
      isExpandedFirst: false,
      isExpandedSecond: false,
      saveRation: false,
      createRation: false,
      showSubGroupAnimalDetails: false,
      allAnimalsData: [],
      rationIds: [],
      suggestions: [],
      rationLists: [],
      individualAnimals: [],
      rationPriority: null,
      currentAnimalRation: null,
    };
  },
  methods: {
    enableSaveRationBtn() {
      let data = this.suggestions.map((s) => {
        return ["active", "suggested"].includes(s.ration.status_type);
      });

      return data.includes(false) ? true : false;
    },
    openCreateRationDialog() {
      this.createRation = true;
    },
    openRationCreateModal(item) {
      console.log(item);
      this.currentAnimalRation = item;
      this.saveRation = true;
    },
    expandToggle(animalId) {
      this.$set(this.isExpanded, animalId, !this.isExpanded[animalId]);
    },
    async generateAll() {
      this.startLoading();
      await this.$apollo
        .mutate({
          mutation: generateRationIndividualAnimal,
          variables: {
            generateIndividualRationInput: {
              rationId: +this.rationId,
              individualAnimals: this.individualAnimals,
            },
          },
        })
        .then((res) => {
          this.stopLoading();
          if (res?.data) {
            this.rationLists = [
              {
                ...res?.data?.generateRationIndividualAnimal,
                updateMode: false,
              },
            ];
            this.saveRation = true;
          }

          this.closeModal(true);
        })
        .catch((error) => {
          this.$notify({
            title: "Error!",
            text: error?.graphQLErrors[0].message,
            type: "error",
          });
          this.stopLoading();
        });

      this.stopLoading();
    },
    generateAllData(addOrRemove, data) {
      if (addOrRemove == "add") {
        this.individualAnimals.push(data);
        this.individualAnimals = [
          ...new Set(this.individualAnimals.map(JSON.stringify)),
        ].map(JSON.parse);
      } else {
        this.individualAnimals.splice(
          this.individualAnimals.findIndex((a) => a.animalId == data.animalId),
          1
        );
      }
    },
    generateRations(rationLists) {
      console.log(rationLists);
      this.rationLists = rationLists;
      this.saveRation = true;
      this.loading = false;
    },
    expandToggleFirst() {
      this.isExpandedFirst = !this.isExpandedFirst;
    },
    expandToggleSecond() {
      this.isExpandedSecond = !this.isExpandedSecond;
    },
    rationCreated() {
      this.saveRation = false;
      this.$notify({
        title: "Success!",
        text: "Ration successfully saved.",
        type: "success",
      });
      this.generateSuggestions();
    },
    next() {
      this.$router.push({ name: "IngredientsSelection" });
    },
    back() {
      this.$router.go(-1);
    },
    generateSuggestions() {
      this.startLoading();
      this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation ($data: GenerateIndividualRationSuggestionsInput!) {
              generateSuggestionsForIndividualRation(
                generateIndividualRationSuggestionsInput: $data
              ) {
                id
                rationId
                animalId
                ingredientIds
                noOfRations
                bodyWeightRange
                totalRationQuantity
                totalRationCost
                rationQuantityPerAnimal
                rationCostPerAnimal
                nurtritionalValuePerAnimal
                expiresSoonIngredients {
                  id
                  rationId
                  animalId
                  quantity
                  ingredientId
                  ingredientDetails {
                    id
                    name
                    price
                    quantity
                    nutritionalValues {
                      calcium
                      phosphorus
                      dryMatter
                      tdn
                      crudeProtein
                    }
                  }
                }
                lowCostSuggestion {
                  id
                  rationId
                  animalId
                  quantity
                  ingredientId
                  ingredientDetails {
                    id
                    name
                    price
                    quantity
                    nutritionalValues {
                      calcium
                      phosphorus
                      dryMatter
                      tdn
                      crudeProtein
                    }
                  }
                }
                ration {
                  id
                  name
                  rationCode
                  duration
                  notify_me
                  status_type
                }
              }
            }
          `,
          // Parameters
          variables: {
            data: {
              rationIds: this.rationIds,
              selectedAnimals: this.allAnimalsData.individualAnimals || [],
            },
          },
        })
        .then(async (res) => {
          // console.log(res)
          if (res.data.generateSuggestionsForIndividualRation.length > 0) {
            const data = FeedService.getIndividualIngredientTotalWithData(
              res?.data?.generateSuggestionsForIndividualRation
            );
            console.log("data ========>>>>>>>> ", data);
            this.suggestions = data;
            console.log("suggestions==============>>>>>> ", data);
            this.stopLoading();
          }
          this.stopLoading();
        })
        .catch(async (error) => {
          console.log(error);
          this.$notify({
            title: "Error!",
            text: error?.graphQLErrors[0].message,
            type: "error",
          });
          this.stopLoading();
        });
    },
    destroyIngredientSuggestionDialog(data) {
      this.itemToDelete = data;
      this.deleteSuggestion = true;
      this.this.startLoading();
    },
    async deleteIngredientSuggestionConfirmed(action, item) {
      if (action) {
        this.startLoading();
        let result = await this.$apollo.query({
          query: deleteGeneratedRationIngredient,
          variables: {
            rationId: +this.$route.params.rationId,
            rationSuggestionDetailId: +item.id,
          },
        });

        if (result?.data?.deleteGeneratedRationIngredient) {
          this.stopLoading();
          this.$notify({
            title: "Success!",
            text: "Record deleted successfully!",
            type: "success",
          });
          this.itemToDelete = null;
          this.deleteSuggestion = false;
          this.generateSuggestions();
        } else {
          this.$notify({
            title: "Error!",
            text: "Unable to delete the record!!",
            type: "error",
          });
          this.stopLoading();
        }
      }
    },
  },
  created() {
    if (this.$route.params?.rationIds) {
      this.rationType = this.$route.params.rationType;
      this.rationPriority = this.$route.params.rationPriority;

      if (this.$route.params.selectedAnimals) {
        this.allAnimalsData = JSON.parse(this.$route.params.selectedAnimals);
      }
      console.log("asfasf asf asf ", this.$route.params.rationIds);
      this.rationIds = this.$route.params.rationIds;
      console.log(this.allAnimalsData, "allAnimalsData");

      this.generateSuggestions();
    } else {
      this.$router.push({ name: "SelectAnimalIndividual" });
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-expansion-panel-header,
.v-expansion-panel--active > .v-expansion-panel-header {
  background: #e0f9f1 !important;
  border: none !important;
}

::v-deep .v-expansion-panel-content__wrap {
  padding: 0;
}
</style>
